// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__r4boP","skeleton-progress":"Skeleton_skeleton-progress__G4O_f"};